import { render, staticRenderFns } from "./templetModel.vue?vue&type=template&id=0348c903&scoped=true&"
import script from "./templetModel.vue?vue&type=script&lang=js&"
export * from "./templetModel.vue?vue&type=script&lang=js&"
import style0 from "./templetModel.vue?vue&type=style&index=0&id=0348c903&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0348c903",
  null
  
)

export default component.exports